import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import { handleAuth0OrderClaimCallback } from '../../redux/actions/auth0-callback/auth0CallbackActions';

// Components
import LoadingScreen from '../../components/loading-screen';

const Auth0CallbackOrderClaim = () => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(handleAuth0OrderClaimCallback());
  }, []);

  return <LoadingScreen show />;
};

export default Auth0CallbackOrderClaim;
